import { RepriceDialog } from '@/components/views/dialogs/RepriceDialog'
import type { InventoryFilters } from '@/lib/api/client/inventory'
import type { InventoryListItem } from '@/lib/api/schemas/inventory.schema'
import type { SelectionAction } from '@/lib/views/actions'

function hasLiveStorefrontPrice(row: InventoryListItem): boolean {
  return (row.storefrontPrices ?? []).some((price) => price.listed && price.price !== null)
    || (row.ymarketEconomics !== null && row.ymarketEconomics !== undefined)
}

export const REPRICE_SELECTION_ACTION: SelectionAction<'inventory', InventoryListItem, InventoryFilters, 'reprice'> = {
  key: 'reprice',
  grain: 'inventory',
  label: 'Переоценить',
  eligible: (row) => hasLiveStorefrontPrice(row)
    ? { ok: true }
    : { ok: false, reason: 'Нет текущей цены на площадке' },
  Dialog: RepriceDialog,
}
